<template>
  <div class="container is-fluid full-viewport" >
    <span style="display:none;" > {{ getToken }} </span>
    <div class="columns is-multiline ">
      <div class="column is-3 " v-for="app in allObjects" :key="app.id_objeto" >
        <div class="container" style="background: white; border: 1px solid;" @click="redireccionar(app.url_applicacion)" >
          <div class="columns is-mobile is-multiline ">
            <div class="column is-12">
              <img
                :src="app.icono"
                style="border-radius:25px;cursor:pointer;max-height: 150px;min-height: 150px;" >
            </div>
            <div class="column is-12 pt-1 " style="background:#CCFF90;max-height:30px;cursor:pointer;border: 1px solid;" >
              <span class="has-text-weight-bold" >
                {{ app.descripcion }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// spr_sel_apps_sesion
export default {
  data () {
    return {
      allObjects: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.token,
    }),
    getToken () {
      this.obtenerObjetos()
      return this.token
    }
  },
  methods: {
    redireccionar (url) {
      location.href = url + '?tk=' + this.token;
    },
    async obtenerObjetos () {
      try {
				const resultado = await this.$api.ejecutar('spr_sel_apps_sesion', [ this.token ])
				if (resultado != null) {
          this.allObjects = [ ...resultado ]
          this.allObjects.sort(function (o1, o2) {
            if (o1.orden_visualizacion > o2.orden_visualizacion) {
              return 1
            } else if (o1.orden_visualizacion < o2.orden_visualizacion) {
              return -1
            } 
            return 0
          })
        }
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    }
  }
}
</script>